module.exports = __webpack_public_path__ + "static/media/back.290174b6.svg";